import { getUserRoles } from '@edge/spark/io-roles'
import { QueryResolvers } from '../../../../../generated/graphql'

export const rolesResolver: QueryResolvers['roles'] = async (_, __, { client }) => {
    console.debug('rolesResolver deprecated, use getUserRoles')
    const roles = await getUserRoles({ client })

    return roles
}
